"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _epic = _interopRequireDefault(require("settings-ui-sdk/EspSync/epic"));

var _epic2 = _interopRequireDefault(require("settings-ui-sdk/EspSyncOAuth/epic"));

var _UpdateEspSync = _interopRequireDefault(require("settings-ui-modules/marketing/modules/esp-sync/stagedObjects/UpdateEspSync"));

var _LaboratoryEpic = _interopRequireDefault(require("settings-ui-sdk/Laboratory/LaboratoryEpic"));

var _default = (0, _reduxObservable.combineEpics)(_epic.default, _epic2.default, _UpdateEspSync.default.getResetChangesToStagedObjectEpic(), _LaboratoryEpic.default);

exports.default = _default;
module.exports = exports.default;